import { get } from "./api";

export const fetchProfitLossData = (customer_id, formattedStartDate, formattedEndDate, signal) => {
    return get(`/api/v2/customers/${customer_id}/profitlossexport/${formattedStartDate}/${formattedEndDate}`, {}, false, signal);
  };

export const fetchBalanceSheetData = (customer_id, formattedEndDate, signal) => {
    return get(`/api/v2/customers/${customer_id}/balancesheetexport/${formattedEndDate}`, {}, false, signal);
  };

  export const fetchRoyaltyData = (customer_id, formattedStartDate, formattedEndDate, signal) => {
    return get(`/api/v2/customers/${customer_id}/royaltyexport/${formattedStartDate}/${formattedEndDate}`, {}, false, signal);
  };
